<script setup>
import { ref, onMounted, reactive, computed, watch } from 'vue'

const props = defineProps({
  title: {
    default: "",
  },
  border: {
    default: true,
  },
});

let styles = computed(() => {
  return {
    InputGroup: props.border,
    InputGroupNotBordered: !props.border,
  }
});

</script>

<template>
  <div class="mb-s" :class="styles">
    <p v-if="title" class="header mb-xs">{{title}}</p>
    <div class="input-group-content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.InputGroup {
  max-width: 1000px;
  border: 1px solid var(--b-20);
  border-radius: var(--br-s);
  padding: var(--s) var(--m);
}

.InputGroupNotBordered {
  max-width: 1000px;
  padding: var(--xs) 0;
}

.header {
  color: var(--pc-darkest);
  font-weight: 600;
  font-size: var(--f-s);
  display: inline-block;
  text-transform: uppercase;
  font-weight: bold;
}

.input-group-content {
}
</style>
